import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CRatReducao extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	form = {
		aliquot: 3,
		months: 60,
		monthlySalaries: '',
	}

	advanced = {
		selic: 1.25,
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
	}

	get ratValue() {
		const monthlySalaries = parseFloat(
			this.form.monthlySalaries.replaceAll('.', '').replaceAll(',', '.'),
		)
		const result = this.parse(monthlySalaries * (this.form.aliquot / 100))
		return currencyFormat(result)
	}

	get ratLiquidValue() {
		const ratValue = parseFloat(
			this.ratValue.replaceAll('.', '').replaceAll(',', '.'),
		)
		const aliquotBenefits = 0.1428 + 0.0769 + 0.0256 + 0.02

		const result = ratValue * (1 - aliquotBenefits)
		return currencyFormat(result)
	}

	get monthlySavings() {
		const ratValue = parseFloat(
			this.ratValue.replaceAll('.', '').replaceAll(',', '.'),
		)
		const ratLiquidValue = parseFloat(
			this.ratLiquidValue.replaceAll('.', '').replaceAll(',', '.'),
		)

		const result = this.parse(ratValue - ratLiquidValue)

		this.$emit('savings', result)

		return currencyFormat(result)
	}

	get recuperateOn() {
		const monthlySavings = parseFloat(
			this.monthlySavings.replaceAll('.', '').replaceAll(',', '.'),
		)
		const result = this.parse(
			monthlySavings * this.form.months * this.advanced.selic,
		)
		this.$emit('recuperate', result)
		return currencyFormat(result)
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	parse(n) {
		if (isNaN(n)) return 0
		n = parseFloat(n)
		return parseFloat(n.toFixed(3))
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.aliquot = this.form.aliquot
			found.months = this.form.months
			found.monthlySalaries = this.form.monthlySalaries
			found.selic = this.advanced.selic
		} else {
			this.calcsEach.unshift({
				id: this.id,
				aliquot: this.form.aliquot,
				months: this.form.months,
				monthlySalaries: this.form.monthlySalaries,
				selic: this.advanced.selic,
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		const rows = () => {
			return [
				[
					{
						label: 'Folha Mensal',
						value: 'R$ ' + this.form.monthlySalaries,
						colSpan: 3,
					},
					{},
					{},
					{
						label: 'Alíquota',
						value: this.form.aliquot + ' %',
					},
				],
				[
					{
						label: 'Valor RAT - Integral',
						value: 'R$ ' + this.ratValue,
						colSpan: 2,
					},
					{},
					{
						label: 'Valor RAT - Líquido',
						value: 'R$ ' + this.ratLiquidValue,
						colSpan: 2,
					},
					{},
				],
				[
					{
						label: 'Economia Mensal',
						value: 'R$ ' + this.monthlySavings,
						colSpan: 2,
					},
					{},
					{
						label: 'Recuperação em ' + this.form.months + ' meses',
						value: 'R$ ' + this.recuperateOn,
						colSpan: 2,
					},
					{},
				],
			]
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.recuperateOn
			found.savings = this.monthlySavings
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'Contribuição ao RAT – redução da base de cálculo',
				color: this.color,
				columns: 4,
				rows: rows(),
				type: 'table',
				recuperate: this.recuperateOn,
				savings: this.monthlySavings,
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			this.form.aliquot = found.aliquot
			this.form.months = found.months
			this.form.monthlySalaries = found.monthlySalaries
			this.advanced.selic = found.selic
		}
	}
}
